module.exports = ":host .ticket-quota__select-box {\n  align-items: center;\n  display: flex;\n  margin-bottom: 2em;\n  width: 100%; }\n  :host .ticket-quota__select-box .ticket-quota__select {\n    margin-left: 5px; }\n    @media (max-width: 992px) {\n      :host .ticket-quota__select-box .ticket-quota__select {\n        margin-bottom: 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-tickets/ticket-quotas/ticket-quotas.scss
// module id = f2Un
// module chunks = 12